import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const CorporateInfo = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
      }}
    >
      {/* Header */}
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Container
          fluid
          style={{
            maxWidth: isMobile ? '100%' : '85%',
            padding: 'clamp(1rem, 3vw, 1.5rem)',
          }}
        >
          <div className='d-flex justify-content-between align-items-center text-white'>
            <Button
              variant='link'
              onClick={() => navigate(-1)}
              className='text-white p-0'
              aria-label='Go back'
            >
              <i className='bi bi-arrow-left fs-4'></i>
            </Button>
            <h5 className='mb-0 fw-bold'>Corporate Information</h5>
            <div style={{ width: '24px' }}></div>
          </div>
        </Container>
      </div>

      {/* Main Content */}
      <Container
        fluid
        style={{
          maxWidth: isMobile ? '100%' : '85%',
          padding: 'clamp(1rem, 3vw, 1.5rem)',
          backgroundColor: '#FFFFFF',
          minHeight: '100vh',
        }}
      >
        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <h5 className='fw-bold mb-3'>Company Overview</h5>
          <p className='mb-4'>
            We are a digital asset technology company focused on providing
            cryptocurrency market data, exchange-related services, and financial
            technology solutions to users worldwide. The platform is designed to
            support transparency, security, and ease of use across all supported
            services.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Business Operations</h5>
          <p className='mb-4'>
            The company operates an online platform that provides access to
            cryptocurrency price information, market insights, and related
            digital services. We do not provide financial, legal, or investment
            advice. All users are responsible for understanding the risks
            associated with digital assets before using the platform.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Security & Data Protection</h5>
          <p className='mb-4'>
            We apply industry-standard security measures to protect user data,
            system integrity, and platform availability. While we strive to
            maintain a secure environment, no digital platform can guarantee
            absolute security. Users are encouraged to protect their accounts
            and credentials at all times.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Corporate Responsibility</h5>
          <p className='mb-4'>
            We are committed to ethical business practices, transparency, and
            responsible innovation. Our goal is to contribute positively to the
            global digital asset ecosystem while complying with applicable laws
            and regulations.
          </p>

          <h5 className='fw-bold mb-3 mt-5'>Contact Information</h5>
          <p className='mb-4'>
            For corporate, legal, or partnership inquiries, please contact us
            through our official communication channels provided on the website.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default CorporateInfo;
